import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AjaxService } from '../../../service/ajax.service';
import { API } from 'src/environments/environment';
import { UserService } from 'src/app/services/user.service';

interface Message {
  id: number;
  senderId: number;
  senderName: string;
  senderAvatar: string;
  content: string;
  timestamp: Date;
  isRead: boolean;
}

@Component({
  selector: 'app-chat-cliente',
  templateUrl: './chat-cliente.component.html',
  styleUrls: ['./chat-cliente.component.scss']
})
export class ChatClienteComponent implements OnInit {
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef;

  messageForm: FormGroup;
  messages: Message[] = [];
  errorMessage: string = '';
  loading: boolean = false;
  user: any;
  private shouldScrollToBottom: boolean = true;

  constructor(
    private fb: FormBuilder,
    private ajaxService: AjaxService,
    private auth: UserService
  ) {
    this.messageForm = this.fb.group({
      message: ['', [Validators.required, Validators.minLength(1)]]
    });
  }

  ngOnInit() {
    this.user = this.auth.getUser();
    this.loadMessages();
  }

  refreshMessages() {
    if (!this.loading) {
      this.loadMessages();
    }
  }

  private loadMessages() {
    this.loading = true;
    this.shouldScrollToBottom = true;
    let url = API + 'Chat/Chat?ID_USUARIO_REMETENTE=' + this.user.Id + "&EH_CLIENTE=true";
    this.ajaxService.get(url).subscribe({
      next: (response) => {
        if (response.data && Array.isArray(response.data)) {
          this.messages = [];
          response.data.forEach(msg => {
            this.messages.push({
              id: msg.iD_CHAT,
              senderId: msg.iD_USUARIO_EMPRESA == 0 ? this.user.Id : 0,
              senderName: msg.iD_USUARIO_REMETENTE == 0 ? 'Você' : 'Cidadania',
              senderAvatar: 'assets/images/user/user-default.png',
              content: msg.mensagem,
              timestamp: new Date(msg.datA_ENVIO),
              isRead: msg.LIDA
            });
          });
        }
        this.loading = false;
        setTimeout(() => this.scrollToBottom(), 100);
      },
      error: (error) => {
        console.error('Erro ao carregar mensagens:', error);
        this.errorMessage = 'Erro ao carregar mensagens. Por favor, tente novamente.';
        this.loading = false;
      }
    });
  }

  sendMessage() {
    if (this.messageForm.valid) {
      const messageContent = this.messageForm.get('message')?.value;

      const messageData = {
        MENSAGEM: messageContent,
        ID_USUARIO_REMETENTE: this.user.Id,
        ID_USUARIO_EMPRESA: 0, // ID da empresa será preenchido pelo backend
        EH_CLIENTE: true
      };

      let url = API + 'Chat/Chat';
      this.ajaxService.post(url, messageData).subscribe({
        next: (response) => {
          // Adiciona a mensagem enviada ao array local
          const newMessage: Message = {
            id: this.messages.length + 1,
            senderId: this.user.Id,
            senderName: 'Você',
            senderAvatar: 'assets/images/user/user-default.png',
            content: messageContent,
            timestamp: new Date(),
            isRead: true
          };

          this.messages.push(newMessage);
          this.messageForm.reset();
          this.shouldScrollToBottom = true;
          setTimeout(() => this.scrollToBottom(), 100);
        },
        error: (error) => {
          console.error('Erro ao enviar mensagem:', error);
          this.errorMessage = 'Erro ao enviar mensagem. Por favor, tente novamente.';
        }
      });
    }
  }

  private scrollToBottom(): void {
    if (!this.shouldScrollToBottom) return;
    
    try {
      const element = this.messagesContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
    } catch (err) {
      console.error('Erro ao rolar para o final da conversa:', err);
    }
  }

  onScroll(event: any): void {
    const element = event.target;
    const atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
    this.shouldScrollToBottom = atBottom;
  }

  formatMessageTime(date: Date): string {
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatMessageDate(date: Date): string {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Hoje';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Ontem';
    } else {
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }
} 